export type BundleFormKey = `bundleGroups.${number}.bundles.${number}`;
export type MetaFormKey = `${BundleFormKey}.metaTemplates.${number}`;
export type DeltaFormKey = `${BundleFormKey}.deltaTemplates.${number}`;
export type CustomFormKey = `${BundleFormKey}.customTemplates.${number}`;

export type TicketsNotificationFormKey =
  | BundleTicketsNotificationFormKey
  | TemplateTicketsNotificationFormKey;

export type EmailsNotificationFormKey =
  | TemplateEmailsNotificationFormKey
  | BundleEmailsNotificationFormKey;

type TemplateEmailsNotificationFormKey = `${CustomFormKey}.emails`;
type TemplateTicketsNotificationFormKey = `${CustomFormKey}.tickets`;
type BundleEmailsNotificationFormKey = `${BundleFormKey}.emails`;
type BundleTicketsNotificationFormKey = `${BundleFormKey}.tickets`;

export function formKey(
  bundleGroupIndex: number,
  bundleIndex: number,
  templateIndex: number,
  templateType: "meta"
): [MetaFormKey, BundleFormKey];

export function formKey(
  bundleGroupIndex: number,
  bundleIndex: number,
  templateIndex: number,
  templateType: "delta"
): [DeltaFormKey, BundleFormKey];

export function formKey(
  bundleGroupIndex: number,
  bundleIndex: number,
  templateIndex: number,
  templateType: "custom"
): [CustomFormKey, BundleFormKey];

/**
 * Helper function to generate keys that are passed to form elements using react-hook-form.
 * Overloads are important for type safety since react-hook-form is stricly typed.
 * @param bundleGroupIndex  Currently selected bundle group
 * @param bundleIndex  Currently selected bundle in which to edit/add a Campaign Template.
 * @param templateIndex  Currently selected Campaign Template in which to edit/add a Campaign Template.
 * @returns A tuple of two strings. The first is the key for the Campaign Template. The second is the key for the Bundle.
 */
export function formKey(
  bundleGroupIndex: number,
  bundleIndex: number,
  templateIndex: number,
  templateType: "meta" | "delta" | "custom"
) {
  return [
    `bundleGroups.${bundleGroupIndex}.bundles.${bundleIndex}.${templateType}Templates.${templateIndex}`,
    `bundleGroups.${bundleGroupIndex}.bundles.${bundleIndex}`
  ];
}

export function getBundleKey(
  bundleGroupIndex: number,
  bundleIndex: number
): BundleFormKey {
  return `bundleGroups.${bundleGroupIndex}.bundles.${bundleIndex}`;
}
